import {Image, Text, TouchableOpacity, View} from 'react-native';
import React, {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {fetchQuestionsChange, selectQuestions} from '../../store/xueke';
import {
  WebviewCustomerMemo,
  WebviewCustomerRef,
} from '../../components/WebviewCustomer';
import {AIWebviewURL} from '../../env/webviewUrl';
import {createStyles} from '../../utils/createStyles';
import {downloadXkwUserGenerateRecordFileUrl} from '../../API/mylearn';
import QRCodeModal from '../../components/Url2QRCode';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import Toast from 'react-native-toast-message';
import {useRoute} from '@react-navigation/native';
import {middlewareType} from '../../utils/webviewJSBridge';
const styles = createStyles({
  workBookDetailsBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    paddingLeft: '1.65rem',
    paddingRight: '1.15rem',
    paddingVertical: '1.2rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  workBookDetailsBoxWeb: {
    backgroundColor: '#fff',
    flex: 1,
    height: '100%',
    borderRadius: '1rem',
    padding: '1.5rem',
  },
  workBookDetailsBoxBtn: {
    marginLeft: '1.3rem',
    width: '7.25rem',
    height: '23rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  workBookDetailsBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },
});
const WorkbookDetails = ({route}: any) => {
  console.log('params', route);
  const dispatch = useAppDispatch();
  const questions = useAppSelector<any>(selectQuestions);
  const webviewRef = useRef<WebviewCustomerRef>(null);
  const url = `${AIWebviewURL}/XKW/questions`;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qrcodeValue, setQrcodeValue] = useState('');
  const [questionRecordId, setQuestionRecordId] = React.useState(0);
  const [changeNum, setChangeNum] = React.useState<number>(0);
  useEffect(() => {
    setQrcodeValue('');
    if (route.params?.id) {
      setQuestionRecordId(route.params?.id);
      return;
    }
    setQuestionRecordId(questions.generateRecordId);
  }, [questions, route]);
  const handleWebViewLoadEnd = () => {
    webviewRef.current?.sendMessage({
      eventName: 'onQuestions',
      data: {
        questions: questions.data,
        sub_title:
          '学校：________ 姓名：________ 班级：________ 考号：________',
        title: route.params?.title
          ? route.params?.title
          : `同步练习测试 ${new Date().toLocaleDateString()}`,
      },
    });
  };
  const handleDownLoadFile = async () => {
    showGlobalLoading({text: '下载中'});
    let timer: any,
      count = 0;

    // 最长 60s 倒计时，超时则取消 每 1 秒请求一次 返回值之后停止倒计时
    timer = setInterval(async () => {
      try {
        const p = {
          generateRecordId: questionRecordId,
        };
        const resaa = await downloadXkwUserGenerateRecordFileUrl(p);
        console.log('1112', resaa);
        if (!resaa) {
          console.log('我进来了');
          clearInterval(timer);
          hideGlobalLoading();
        }
        count++;
        if (count > 60) {
          clearInterval(timer);
        }
        if (resaa.data.status === 2) {
          clearInterval(timer);
          hideGlobalLoading();
          // @ts-ignore
          setQrcodeValue(resaa.data.url);
          setIsModalVisible(true);
        }
        if (resaa.data.status === 3) {
          Toast.show({
            type: 'error',
            text1: '文件下载失败，请稍后重试',
          } as any);
          clearInterval(timer);
          hideGlobalLoading();
        }
        console.log('res', resaa);
      } catch (e) {
        hideGlobalLoading();
        clearInterval(timer);
        console.log(e);
      }
    }, 5000);
  };
  const handleChangeQuestion = () => {
    // 增加一个逻辑，只能切换一套
    if (changeNum > 0) {
      Toast.show({
        type: 'error',
        text1: '今日生成次数已用尽，明日再来',
      });
      return;
    }
    setQrcodeValue('');
    showGlobalLoading({text: '加载中'}); // 显示加载提示
    dispatch(fetchQuestionsChange({generateRecordId: questionRecordId}))
      .unwrap()
      .then(res => {
        console.log(res);
        if (res) {
          setChangeNum(prev => prev + 1);
          webviewRef.current?.sendMessage({
            eventName: 'onQuestions',
            data: {
              questions: res.data,
              sub_title:
                '学校：________ 姓名：________ 班级：________ 考号：________',
              title: route.params?.title
                ? route.params?.title
                : `同步练习测试 ${new Date().toLocaleDateString()}`,
            },
          });
        }
      })
      .catch(error => {
        console.error(error); // 打印错误
        // 可以在这里添加任何你需要的错误处理逻辑
      })
      .finally(() => {
        hideGlobalLoading(); // 关闭加载提示
      });
  };
  const webEventHandle: middlewareType = (eventName, data, res) => {
    switch (eventName) {
      case 'WebMounted': {
        console.log('WebMounted');
        handleWebViewLoadEnd();
        break;
      }
    }
  };
  return (
    <View style={styles.workBookDetailsBox}>
      <View style={styles.workBookDetailsBoxWeb}>
        <WebviewCustomerMemo
          ref={webviewRef}
          eventHandle={webEventHandle}
          url={url}
          onLoadEnd={handleWebViewLoadEnd}
        />
      </View>
      <View style={styles.workBookDetailsBoxBtn}>
        {!route.params?.id && (
          <TouchableOpacity
            activeOpacity={1}
            onPress={handleChangeQuestion}
            style={styles.workBookDetailsBoxBtnItem}>
            <Image
              style={styles.workBookDetailsBoxBtnItemImg}
              source={{
                uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_refresh.png',
              }}
            />
            <Text style={styles.workBookDetailsBoxBtnItemText}>换一套</Text>
          </TouchableOpacity>
        )}

        <TouchableOpacity
          activeOpacity={1}
          onPress={handleDownLoadFile}
          style={styles.workBookDetailsBoxBtnItem}>
          <Image
            style={styles.workBookDetailsBoxBtnItemImg}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_download.png',
            }}
          />
          <Text style={styles.workBookDetailsBoxBtnItemText}>下载试题</Text>
        </TouchableOpacity>
      </View>
      <QRCodeModal
        visible={isModalVisible}
        logoImg={
          'https://media.oss.leziedu.com/webapp/classroom/mylearn/logoC.png'
        }
        value={qrcodeValue}
        onClose={() => {
          setIsModalVisible(false);
        }}
      />
    </View>
  );
};

export default WorkbookDetails;
